import { render, staticRenderFns } from "./TwImageCarousel.vue?vue&type=template&id=42e7ceff&scoped=true"
import script from "./TwImageCarousel.vue?vue&type=script&lang=js"
export * from "./TwImageCarousel.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./TwImageCarousel.vue?vue&type=style&index=0&id=42e7ceff&prod&scoped=true&lang=css")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "42e7ceff",
  null
  ,true
)

export default component.exports